import { FC } from 'react';
import { PageTitle, PageLink } from '../../../_metronic/layout/core';
import { View } from './components/View';
import { useLocation } from 'react-router-dom';

const CotizacionPage: FC = () => {
  let location = useLocation();
  const lastPathSegment: any = location.pathname.split('/').pop();
  let lastSegmentTitle = lastPathSegment
    ? lastPathSegment.charAt(0).toUpperCase() + lastPathSegment.slice(1)
    : '';
  let title: string =
    lastSegmentTitle === 'Cotizaciones' ? 'Mis cotizaciones' : 'Cotizaciones';

  if (lastSegmentTitle === 'Cotizaciones') {
    title = 'Cotizaciones';
    lastSegmentTitle = 'Mis cotizaciones';
  }
  const breadCrumbs: Array<PageLink> = [
    {
      title: title,
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>{lastSegmentTitle}</PageTitle>
      <View />
    </>
  );
};

export { CotizacionPage };
